<template>
  <div>

    <PersonalNav v-if="isRouterAlive" />
    <TypeNav :obj="TypeRoute" />
    <router-view></router-view>
    <VFoot :obj="FooterData" />
    <Login />
    <el-backtop :bottom="100" :right="15">
      <i class="iconfont icon-xiangshang" style="font-size: 50px;color: #F74747;"></i>
    </el-backtop>
  </div>
</template>

<script>
import VHeader from '@/components/base/v-header'
import VFoot from '@/components/base/v-foot'
import PersonalNav from '@/components/common/TopPersonalNav'
import TypeNav from '@/components/common/TopTypeNav'
import Login from '@/views/login/index'
export default {
  name: 'layout',
  components: { Login, VFoot, PersonalNav, TypeNav },
  data() {
    return {

      isRouterAlive: true,
      TypeRoute: {},
      FooterData: {}
    }
  },
  watch: {

  },
  created() {
    //this.getCanvas()
    // 在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('messageStore', JSON.stringify(this.$store.state))
    })
    // 在页面加载时读取localStorage里的状态信息
    localStorage.getItem('messageStore') && this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(localStorage.getItem('messageStore'))))
  },
  methods: {


  }
}
</script>
<style lang="scss">
#app {
  min-width: 1440px;
  background-color: #F6F6F8;
}

.el-loading-mask {
  .el-loading-spinner {
    .path {
      stroke: #333333;
    }
  }
}

// loading
.el-loading-spinner {

  i,
  .el-loading-text {
    font-size: 18px;
    color: #333333;
  }
}

.pagination {
  padding: 30px 0;
  max-width: 1280px;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}

// ::-webkit-scrollbar {
//   width: 6px;
//   height: 6px;

//   background-color: transparent;

// }
// ::-webkit-scrollbar-thumb {
//   background-color: #F74747;
//   border-radius: 10px;
// }
// ::-webkit-scrollbar-track {
//   background-color: transparent;
// }
</style>



// WEBPACK FOOTER //
// src/views/layout.vue